import Client from "./client";

// Where this installation's Help link points. No access token: the answer is a
// public support code, and the login and sign-up pages need it too.
//
// Never rejects. Not having a help desk configured is an ordinary state of an
// installation rather than an error, and the caller's job is to hide a link -
// so a failure and "none configured" are deliberately the same answer. A Help
// link that threw on every page load would be worse than one briefly missing.
export const GetHelpPortal = () => {
    return new Promise((resolve) => {
        Client.get('/api/public/help').then((res) => {
            resolve(res.data || { available: false, code: null });
        }).catch(() => {
            resolve({ available: false, code: null });
        })
    })
}
